export default __webpack_public_path__ + "static/media/location.c9281973.svg";